export default __webpack_public_path__ + "static/media/coloringbook.9f5d3431.png";